/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GrantPK } from './GrantPK';
import {
    GrantPKFromJSON,
    GrantPKFromJSONTyped,
    GrantPKToJSON,
} from './GrantPK';

/**
 * 
 * @export
 * @interface CreateDarRecipientDto
 */
export interface CreateDarRecipientDto {
    /**
     * 
     * @type {GrantPK}
     * @memberof CreateDarRecipientDto
     */
    darGrantPK?: GrantPK;
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof CreateDarRecipientDto
     */
    workflowInstanceAssignedTaskId?: string;
}

/**
 * Check if a given object implements the CreateDarRecipientDto interface.
 */
export function instanceOfCreateDarRecipientDto(value: object): boolean {
    return true;
}

export function CreateDarRecipientDtoFromJSON(json: any): CreateDarRecipientDto {
    return CreateDarRecipientDtoFromJSONTyped(json, false);
}

export function CreateDarRecipientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDarRecipientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'darGrantPK': json['darGrantPK'] == null ? undefined : GrantPKFromJSON(json['darGrantPK']),
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
    };
}

export function CreateDarRecipientDtoToJSON(value?: CreateDarRecipientDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'darGrantPK': GrantPKToJSON(value['darGrantPK']),
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
    };
}

